// Takeoff Canvas 2.0 Track A1 — dark drawing view (TAKEOFF_CANVAS_2_ROADMAP.md
// A1, UI brief §25). A render concern only: the source PDF / raster is never
// modified — the drawing layer is inverted with a CSS filter on the SVG
// <image> (hue-rotated so colored linework keeps its hue), the canvas ground
// goes dark, and the markup chrome that assumed a light ground (label halos,
// dark text, the 5 ft grid) switches to dark-legible values. Room / condition
// colors are the catalog's own and are left alone. Anything that leaves the
// canvas (print, export, the keyplan's bitmap) is a separate, explicit call:
// this filter applies only where `rasterFilter` is used.

export const DARK_DRAWING_STORAGE_KEY = "cs-takeoff-dark-drawing";

// The two palettes the canvas renders under. `light` is exactly what the
// canvas did before A1 (theme tokens), so the default view is unchanged.
export const DRAWING_VIEWS = Object.freeze({
  light: Object.freeze({
    key: "light",
    canvasBg: "var(--surface)",
    rasterFilter: "none",
    gridStroke: "var(--cs-border)",
    gridOpacity: 0.6,
    labelHalo: "var(--surface)",
    textFill: "var(--text)",
    scaleBarStroke: "var(--text)",
  }),
  dark: Object.freeze({
    key: "dark",
    canvasBg: "#0b1220",
    rasterFilter: "invert(1) hue-rotate(180deg)",
    gridStroke: "rgba(148, 163, 184, 0.55)",
    gridOpacity: 0.5,
    labelHalo: "#0b1220",
    textFill: "#e2e8f0",
    scaleBarStroke: "#e2e8f0",
  }),
});

export const drawingView = (dark) => (dark ? DRAWING_VIEWS.dark : DRAWING_VIEWS.light);

// Per-viewer convenience only (a view preference, not estimate data) — read
// and written under try/catch because storage can be blocked or empty.
export function readDarkDrawingPreference(storage = typeof localStorage !== "undefined" ? localStorage : null) {
  try { return storage?.getItem(DARK_DRAWING_STORAGE_KEY) === "1"; } catch { return false; }
}
export function writeDarkDrawingPreference(dark, storage = typeof localStorage !== "undefined" ? localStorage : null) {
  try { storage?.setItem(DARK_DRAWING_STORAGE_KEY, dark ? "1" : "0"); return true; } catch { return false; }
}
